<template>
  <div id="skinNotificator"></div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  checkIsMobileDevice,
  checkIsTabletDevice
} from '@/plugins/device-inspector';
import { EventBus } from '@/plugins/eventBus';
import { useApiV3 } from '@/composables/apiV3';

/* todo write here all the listener message for toolbar notification */
export default {
  name: 'GenericSkinListener',
  components: {},
  data: () => ({
    isHomepageActive: true
  }),
  mounted() {
    console.log('[MOUNTED GENERICSKINLISTENER]');
    window.addEventListener('message', this.handleMessage);
    this.sendModeMessageToSkinV2();
    //TEST ILLINOIS ROUTING
    /* setTimeout(() => {
        window.postMessage(
          {
            type: 'openMatchDetail',

            tournamentId: '7168457170',
            sportId: '8412615417',
            categoryId: '9048397214'
          },
          window.origin
        );
      }, 500); */
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  computed: {
    ...mapGetters({
      getPreview: 'odds/getPreview',
      getEventsDetail: 'odds/getEventsDetail',
      getLiveMode: 'odds/getLiveMode',
      getProgramOpen: 'settings/getProgramOpen',
      getIsCartOpen: 'cart/getIsCartOpen',
      getBetOdds: 'cart/getBetOdds',
      getBet: 'cart/getBet',
      getShowCart: 'IllinoisSport/getShowCart'
    })
  },
  methods: {
    ...mapActions({
      setStatusQbet: 'tree/setStatusQbet',
      setLoadingPreview: 'odds/setLoadingPreview',
      fetchPreview: 'odds/fetchPreview',
      setLiveMode: 'odds/setLiveMode',
      setIsCartOpen: 'cart/setIsCartOpen',
      fetchBookedBet: 'cart/fetchBookedBet',
      setLoadingCart: 'cart/setLoadingCart',
      fetchAntepost: 'odds/fetchAntepost',
      setHeightOfParentIframe: 'settings/setHeightOfParentIframe',
      setOpenSportTree: 'IllinoisSport/setOpenSportTree',
      setShowCart: 'IllinoisSport/setShowCart'
    }),

    /* async searchEventsByKeyword(keyword) {
      const { findEvents } = useApiV3();
      try {
        const results = await findEvents({ search: keyword });
        window.parent.postMessage(
          {
            type: 'sportSearchResults',
            results: results
          },
          '*'
        );
      } catch (error) {
        window.parent.postMessage(
          {
            type: 'sportSearchResults',
            error: (error && error.message) || String(error)
          },
          '*'
        );
      }
    }, */

    checkIsMobile() {
      return checkIsMobileDevice();
    },

    checkIsTablet() {
      return checkIsTabletDevice();
    },

    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode });
    },

    async getDetailAntepost(element) {
      const vm = this;
      document.body.scrollIntoView({ behavior: 'smooth' });
      window.parent.postMessage(
        {
          type: 'scrollTop'
        },
        '*'
      );
      this.setStatusQbet(false);
      const idEvent = element.id;
      const typeOdds = 'antepost';
      await this.setLoadingPreview({ status: true });
      await this.fetchAntepost({
        idEvent: idEvent,
        type: typeOdds,
        source: element.id + '#antepost'
      });
      if (this.checkIsMobile() || this.checkIsTablet()) {
        this.$root.$emit('close_sidebar_left', true);
        this.changeLiveMode('preview');
      }
      await this.setLoadingPreview({ status: false });
    },
    async getDetailTournament(sport, element) {
      document.body.scrollIntoView({ behavior: 'smooth' });
      window.parent.postMessage(
        {
          type: 'scrollTop'
        },
        '*'
      );
      this.setStatusQbet(false);
      const split = element.id.split('#');
      const typeOdds = 'previewOdds';
      await this.setLoadingPreview({ status: true });
      await this.fetchPreview({
        tournament: split[0],
        type: typeOdds,
        source: element.id,
        sportId: element.sportId,
        forceDefaultGameConsole: false,
        mobilePlatform: this.checkIsMobile() || this.checkIsTablet(),
        groupOddsWithSpreads: true,
        sportName: sport.name,
        tournamentName: element.name
      });
      if (this.checkIsMobile() || this.checkIsTablet()) {
        // this.$root.$emit('close_sidebar_left', true)
        this.changeLiveMode('preview');
      }
      await this.setLoadingPreview({ status: false });
    },

    isHomePage() {
      if (this.getPreview.length > 0 || this.getEventsDetail.length > 0) {
        this.isHomepageActive = false;
      } else {
        this.isHomepageActive = true;
      }
    },
    async getBookedBet(betCode) {
      this.valid = betCode != '';
      if (this.valid) {
        await this.setLoadingCart({ status: true });
        const bet = await this.fetchBookedBet({ code: betCode });
        if (!bet.result) {
          await this.setLoadingCart({ status: false });
        } else {
          await this.setLoadingCart({ status: false });
        }
      } else {
        console.log('[DEBUG] getBookedBet not valid');
      }
    },

    handleMessage(event) {
      if (event != null && event.data != null && event.data.type != null) {
        switch (event.data.type) {
          case 'openMatchDetail':
            console.log('openMatchDetail');
            console.log('event.data', event.data);
            this.getDetailTournament(event.data.sport, event.data.element);
            //INIZIO MODIFICA PER TESTARE ROUTING ILLINOIS SPORT
            /* console.log('event.data.sport', event.data.sport);
            console.log('event.data.element', event.data.element);
            this.$router.push({
              name: 'IllinoisTournament',
              params: {
                tournamentId: event.data.tournamentId
              },
              query: {
                sportId: event.data.sportId,
                categoryId: event.data.categoryId
              }
            }); */
            //FINE MODIFICA PER TESTARE ROUTING ILLINOIS SPORT
            break;
          case 'openAntepostDetail':
            console.log('openAntepostDetail');
            console.log('event.data', event.data);

            this.getDetailAntepost(event.data.element);
            break;
          case 'openOrCloseCart':
            console.log('openOrCloseCart');
            console.log('event.data', event.data);
            if (this.checkIsMobile() || this.checkIsTablet()) {
              this.$root.$emit('cart_handling', true);
            } else {
              this.setIsCartOpen(!this.getIsCartOpen);

              setTimeout(() => {
                EventBus.$emit('refreshedCartWithOdd'); // fix me this is a working around problem
              }, 50);
            }
            break;
          case 'getBookedBetFromSkin':
            console.log('getBookedBetFromSkin');
            console.log('event.data', event.data);
            this.setIsCartOpen(true);
            this.getBookedBet(event.data.betCode);
            break;
          case 'filterLiveEvents':
            console.log('filterLiveEvents');
            console.log('event.data', event.data);
            this.$root.$emit(
              'filter_live_preview_category',
              event.data.category
            );
            break;
          case 'adjustHeightOfScreen':
            console.log('adjustHeightOfScreen');
            console.log('event.data', event.data);
            this.setHeightOfParentIframe(event.data.height);
            break;
          case 'illinoisNavigateToSport':
            console.log('illinoisNavigateToSport');
            console.log('event.data', event.data);
            this.$router.push({
              name: 'IllinoisSport',
              params: {
                sportId: event.data.sportId
              }
            });
            break;
          case 'openSportPage':
            console.log('illinoisNavigateToSport');
            console.log('event.data', event.data);
            this.$router.push({
              name: 'IllinoisHome'
            });
            break;
          case 'openSportTree':
            console.log('openSportTree');
            console.log('event.data', event.data);
            this.setOpenSportTree(true);
            break;
          case 'toggleIllinoisCart':
            console.log('toggleIllinoisCart');
            console.log('event.data', event.data);
            const newCartState1 = !this.getIsCartOpen;
            this.setIsCartOpen(newCartState1);
            this.setShowCart(newCartState1);
            break;

          case 'toggleSportCart':
            console.log('toggleIllinoisCart');
            console.log('event.data', event.data);
            const newCartState = !this.getIsCartOpen;
            this.setIsCartOpen(newCartState);
            this.setShowCart(newCartState);
            break;

          case 'openIllinoisLive':
            console.log('openIllinoisLive');
            console.log('event.data', event.data);
            this.$router.push({
              name: 'IllinoisLive'
            });
            break;
          case 'openLiveSportPage':
            console.log('openIllinoisLive');
            console.log('event.data', event.data);
            this.$router.push({
              name: 'IllinoisLive'
            });
            break;
          case 'illinoisNavigateToHome':
            console.log('illinoisNavigateToHome');
            console.log('event.data', event.data);
            this.$router.push({
              name: 'IllinoisHome'
            });
            break;
          case 'openHomeSportPage':
            console.log('illinoisNavigateToHome');
            console.log('event.data', event.data);
            this.$router.push({
              name: 'IllinoisHome'
            });
            break;
          case 'useAmericanOutcomeValue':
            console.log('useAmericanOutcomeValue');
            console.log('event.data', event.data);
            this.setUseAmericanOutcomeValue(event.data.value);
            break;
          default: {
            console.log('else');
            console.log('event.data', event.data);
            break;
          }
          /* case 'searchEventByKeyword':
            this.searchEventsByKeyword(event.data.keyword);
            break; */
        }
      }
    },
    sendModeMessageToSkin() {
      const vm = this;
      window.parent.postMessage(
        {
          type: 'sportMode',
          mode: vm.getLiveMode
        },
        '*'
      );
    },
    sendCartOpen(value) {
      const vm = this;
      window.parent.postMessage(
        {
          type: 'openCart',
          mode: value
        },
        '*'
      );
    },
    sendModeMessageToSkinV2() {
      const vm = this;
      window.parent.postMessage(
        {
          type: 'sportModeWithTreeInfo',
          mode: vm.getLiveMode,
          treeStatus: vm.getProgramOpen
        },
        '*'
      );
    },
    postChartValue(value) {
      window.parent.postMessage(
        {
          type: 'counterChart',
          counterChart: value
        },
        '*'
      );
    }
  },
  watch: {
    async getIsCartOpen(val) {
      this.sendCartOpen(val);
    },
    async getBetOdds() {
      this.postChartValue(this.getBetOdds.length);
    },
    getPreview(newVal, oldVal) {
      this.isHomePage();
    },
    getEventsDetail(newVal, oldVal) {
      this.isHomePage();
    },
    isHomepageActive(newVal, oldValue) {
      if (newVal !== oldValue) {
        window.parent.postMessage(
          {
            type: 'statusHomepage',
            status: newVal
          },
          '*'
        );
      }
    },
    getLiveMode(newValue, oldValue) {
      this.sendModeMessageToSkinV2();
    },
    getShowCart(newVal, oldVal) {
      // Sincronizza isCartOpen con showCart
      if (newVal !== oldVal && this.getIsCartOpen !== newVal) {
        this.setIsCartOpen(newVal);
      }
    }
  }
};
</script>

<style scoped></style>
